import { useCallback, useEffect, useState } from 'react';
import { useDevice } from './device';

const useMobileExpanded = (initial: boolean): [boolean, (value: boolean) => void, () => void] => {
  const [isExpanded, setIsExpanded] = useState(initial);
  const device = useDevice();

  const toggleState = useCallback(() => {
    setIsExpanded(prev => !prev);
  }, []);

  useEffect(() => {
    setIsExpanded(initial);
  }, [device]);

  return [isExpanded, setIsExpanded, toggleState];
};

export default useMobileExpanded;
